/* © CNES */
import { Toast } from 'primereact/toast';
import { useContext, useEffect, useRef } from 'react';
import { ConfigContext } from '../../../context/ConfigContext';
import { NotifToastProps } from '../../../models/NotifToastProps';

/**
 * Toast to display link to processings view when a job is completed (sucessful or failed)
 * @returns Element.
 */
export const NotifToast = ({
  summaryTitle,
  displayMessage,
  displaySeverity,
}: NotifToastProps) => {
  const context = useContext(ConfigContext);
  const toast = useRef<Toast>(null);
  /**
   * Content of the Toast message.
   */
  const detailsContent = (
    <>
      <div>
        <span>{displayMessage}</span>
      </div>
    </>
  );

  /**
   * Display toast.
   */
  const toastDisplay = () => {
    toast.current?.replace({
      severity: displaySeverity,
      summary: summaryTitle,
      detail: detailsContent,
      life: 5000,
    });
  };

  /**
   * Evaluate if jobs swap between running to successful/failed status to trigger toast display.
   */
  useEffect(() => {
    if (context.isError400) {
      toastDisplay();

      setTimeout(() => {
        context.setError400(false);
      }, 5000);
    }
    // eslint-disable-next-line
  }, [context.isError400]);

  return <Toast ref={toast} position="top-center" />;
};
